import { theme } from "ui-components";
import {
  DOMUSO_LEGAL_LINK,
  DOMUSO_PRIVACY_POLICY,
  DOMUSO_ZEN_DESK_LINK_FOR_RESIDENT,
} from "../../../utils";

export const logoAction = (props: any) => {
  const logoAction = {
    icon: null,
    type: "internal",
    path: "Home",
  };

  return logoAction;
};

export const menuOptions = (props: any) => {
  const currentReservation = props.allReservations?.find(
    (reservation) => reservation?.id == props.currentReservationId
  );
  const creditReportingUrl = currentReservation?.property_profile?.credit_reporting_url;

  const menuOptions = [
    {
      order: 5,
      type: "external",
      iconName: "terms-and-condition",
      iconColor: theme.colors.primary,
      title: "header.optionTermAndConditions",
      titleColor: theme.colors.text,
      path: DOMUSO_LEGAL_LINK,
      testingHooks: "menuOptionTermsAndCondition",
    },
    {
      order: 4,
      type: "external",
      iconName: "support",
      iconColor: theme.colors.primary,
      title: "header.optionSupport",
      titleColor: theme.colors.text,
      path: DOMUSO_ZEN_DESK_LINK_FOR_RESIDENT,
      testingHooks: "menuOptionSupport",
    },
    {
      order: 6,
      type: "external",
      iconName: "privacy-policy",
      iconColor: theme.colors.primary,
      title: "header.optionPrivacyPolicy",
      titleColor: theme.colors.text,
      path: DOMUSO_PRIVACY_POLICY,
      testingHooks: "menuOptionPrivacyPolicy",
    },
  ];

  if (props?.options?.showFullMenu) {
    menuOptions.push({
      order: 1,
      type: "internal",
      iconName: "profile",
      iconColor: theme.colors.primary,
      title: "header.optionMyAccount",
      titleColor: theme.colors.text,
      path: "More",
      pathSecondary: "Settings",
      testingHooks: "menuOptionMyAccount",
    });

    menuOptions.push({
      order: 2,
      type: "internal",
      iconName: "payment-method",
      iconColor: theme.colors.primary,
      title: "header.optionPaymentMethods",
      titleColor: theme.colors.text,
      path: "Actions",
      pathSecondary: "WalletPaymentMethods",
      testingHooks: "menuOptionPaymentMethods",
    });
  }

  if (creditReportingUrl) {
    menuOptions.push({
      order: 3,
      type: "external",
      iconName: "build-your-credit",
      iconColor: theme.colors.primary,
      title: "header.optionBuildYourCredit",
      titleColor: theme.colors.text,
      path: creditReportingUrl,
      testingHooks: "menuOptionBuildYourCredit",
    });
  }

  if (props?.isLoggedIn) {
    menuOptions.push({
      order: 7,
      type: "logout",
      iconName: "log-out",
      iconColor: theme.colors.alert,
      title: "header.optionLogOut",
      titleColor: theme.colors.alert,
      testingHooks: "menuOptionLogout",
      path: null,
    });
  }
  return menuOptions;
};
